var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2472 29.5058H29.5058V33.2471H27.0116V29.5058H23.2703V27.0115H27.0116V23.2702H29.5058V27.0115H33.2472V29.5058ZM43.4386 46.9654L34.2262 37.7529C32.4952 38.8429 30.4549 39.4827 28.2587 39.4827C22.0593 39.4827 17.0347 34.4581 17.0347 28.2586C17.0347 22.0592 22.0593 17.0346 28.2587 17.0346C34.4581 17.0346 39.4828 22.0592 39.4828 28.2586C39.4828 30.4548 38.8418 32.4963 37.753 34.2261L46.9655 43.4386L43.4386 46.9654ZM28.2587 36.9885C33.0713 36.9885 36.9885 33.0725 36.9885 28.2586C36.9885 23.4448 33.0713 19.5288 28.2587 19.5288C23.4461 19.5288 19.5289 23.4448 19.5289 28.2586C19.5289 33.0725 23.4461 36.9885 28.2587 36.9885Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomMedia);
export default __webpack_public_path__ + "static/media/zoomMedia.ab5036fa.svg";
export { ForwardRef as ReactComponent };